

class SavingStates {
    static NOT_STARTED = Symbol("NOT_STARTED");
    static SAVING = Symbol("SAVING");
    static FINISHED_SAVING = Symbol("FINISHED_SAVING");
    static FAILED_TO_SAVE = Symbol("FAILED_TO_SAVE");
}

export default SavingStates;
